<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :isTableLoading="isTableLoading"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      tableCardTitle="LIST"
      :row-class-name="tableRowClassName"
    >
      <!--      <template v-slot:dueDate="{ tableRow }">-->
      <!--        <span v-if="greaterThanToday(tableRow.row.dueDate)" style="color: red">-->
      <!--          {{ tableRow.row.dueDate }}-->
      <!--        </span>-->
      <!--        <span v-else style="color: blue">{{ tableRow.row.dueDate }}</span>-->
      <!--      </template>-->
      >
      <template v-slot:dueDate="{ tableRow }">
        <span v-if="greaterThanToday(tableRow.row.dueDate)" style="color: red">
          {{ tableRow.row.dueDate }}
        </span>
        <span v-else style="color: #54afe1">{{ tableRow.row.dueDate }}</span>
      </template>
    </table-view>
  </div>
</template>

<script>
import { getTableData } from './api'
import dayjs from 'dayjs'

export default {
  data() {
    const searchModel = [
      {
        label: 'Parent Company #',
        type: 'input',
        key: 'parentCompanyCode',
      },
      {
        label: 'Parent Company Name',
        type: 'input',
        key: 'parentCompanyName',
      },
      {
        label: 'Assign From',
        type: 'input',
        key: 'assignFromCode',
      },
      {
        label: 'Assign To',
        type: 'input',
        key: 'assignToCode',
      },
    ]
    const tableModel = [
      {
        width: 180,
        label: 'Parent Company #',
        prop: 'companyParentCode',
      },
      {
        minWidth: 200,
        label: 'Parent Company Name',
        prop: 'companyParentName',
      },
      {
        width: 180,
        label: 'Assign From',
        prop: 'assignFromName',
      },
      {
        width: 180,
        label: 'Assign To',
        prop: 'assignToName',
      },
      {
        width: 120,
        label: 'Category',
        prop: 'typeStr',
      },
      {
        width: 180,
        label: 'Amount',
        prop: 'amount',
      },
      {
        width: 120,
        label: 'Due Date',
        slotName: 'dueDate',
      },
    ]
    return {
      today: '',
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      isTableLoading: true,
    }
  },
  mounted() {
    this.initTable()
    this.today = dayjs().format('YYYY-MM-DD')
  },
  methods: {
    tableRowClassName({ row }) {
      if (this.greaterThanToday(row.dueDate)) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    },
    greaterThanToday(date) {
      if (new Date(date).valueOf() < new Date(this.today).valueOf()) {
        return true
      }
      return false
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.tableData.map(item => {
          item.amount = this.$utils.formatAmount(item.amount)
        })
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
  },
}
</script>
